import LazyLoad from 'vanilla-lazyload';

import setupCSRFToken from './setupCSRFToken';
import setupRedirects from './setupRedirects';
import setupStoreTracking from './setupStoreTracking';

declare global {
  interface Window {
    lazyLoadInstance: InstanceType<typeof LazyLoad>;
  }
}

setupCSRFToken();
setupRedirects();
setupStoreTracking();

window.lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy',
});
